export default __webpack_public_path__ + "static/media/editProfile.29418600.svg";